// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2GpHJ","imageUploader":"EGiftCard_imageUploader__3k2E5"};